<template>
  <div class="right-panel">
    <div class="row mb-3">
      <div class="col col-xs-12 col-sm-8 form-input">
        <a title="Back to programs" href="#" @click="backToSelectedParticipants"><i class="bi bi-arrow-left"></i></a>
        <span @click="backToSelectedParticipants" class="back">Back</span>
      </div>
      <div class="col col-xs-6 col-sm-6">
        <h2>Create Email</h2>
      </div>
    </div>
    <div class="table-wrapper">
      <form @submit.prevent="onSubmit">
        <div class="form-group mb-3">
          <label for="emailTo" class="mb-1 mandatory-label">To <i class="bi bi-asterisk mandatory-field"></i></label>

          <vue3-tags-input :tags="emailTo" @on-tags-changed="handleChangeTag" :class="{ 'is-invalid': emailToError }" />
          <div class="invalid-feedback">{{ emailToError }}</div>
        </div>
        <div class="form-group mb-3">
          <label for="emailSubject" class="mb-1 mandatory-label">Subject <i
              class="bi bi-asterisk mandatory-field"></i></label>
          <input class="form-control" id="emailSubject" placeholder="Enter subject" v-model="emailSubject"
            :class="{ 'is-invalid': emailSubjectError }">
          <div class="invalid-feedback">{{ emailSubjectError }}</div>
        </div>
        <div class="form-group mb-3">
          <label for="emailContent" class="mb-1 mandatory-label">Email Content <i class="bi bi-asterisk mandatory-field"></i></label>
          <RichTextEditor v-model="emailContent" :error="emailContentError || undefined" />
        </div>
        <div class="mt-4 d-flex flex-row-reverse">
          <button type="button" class="btn btn-success" @click="onSubmit()">Send Email<i
              class="bi bi-arrow-right icon-space-on-left"></i></button>
        </div>
      </form>
    </div>
  </div>

  <Notification ref="notificationMsg" colorScheme="text-bg-success">
    <template #body>Email sent</template>
  </Notification>
</template>

<script setup lang="ts">
import router from '@/router';
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { onMounted, ref } from "vue";
import { type IEmailParticipants } from "@/types";
import { useEmailStore } from "@/stores/email-store";
import { useRoute } from 'vue-router';
import Notification from '@/components/common/Notification.vue'
import Vue3TagsInput from 'vue3-tags-input';
import { storeToRefs } from "pinia";
const { emailTos, memberIds } = storeToRefs(useEmailStore());
const { sendEmailToParticipants } = useEmailStore();
import RichTextEditor from '@/components/common/RichTextEditor.vue';
const route = useRoute();

const schema = yup.object({
  emailTo: yup.array().of(yup.string()).min(1),
  emailSubject: yup.string().required().label('Subject'),
  emailContent: yup.string().required().label('Email Content'),
});

const { handleSubmit } = useForm({ validationSchema: schema });

const { value: emailTo, errorMessage: emailToError } = useField<string | string[]>("emailTo");
const { value: emailSubject, errorMessage: emailSubjectError } = useField<string>("emailSubject");
const { value: emailContent, errorMessage: emailContentError } = useField<string>("emailContent");

const onInvalidSubmit = ({ values, errors, results }: { values: any, errors: any, results: any }) => {
  console.log("values", values);
  console.log("errors", errors);
  console.log("results", results);
};

const backToSelectedParticipants = async () => {
  await router.push({
    name: 'ParticipationProgramEmail'
  })
};

const memberUID = ref();
onMounted(() => {
  emailTo.value = emailTos.value;
  memberUID.value = memberIds.value;
});

const handleChangeTag = (emailTos: any) => {
  emailTo.value = emailTos;
}

let notificationMsg = ref<any | null>(null)
const onSubmit = handleSubmit(async () => {
  await sendEmailToParticipants({
    emailTos: JSON.stringify(emailTo.value),
    emailSubject: emailSubject.value,
    emailContent: emailContent.value,
    memberIds: JSON.stringify(memberUID.value)
  } as IEmailParticipants);

  notificationMsg.value.show();
  setTimeout(async () => {
    await backToSelectedParticipants();
  }, 3000)

}, onInvalidSubmit)
</script>

<style scoped>
.back {
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
}

.icon-space-on-left {
  margin-left: 2rem;
}
</style>